// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  RequestWidgetDto,
  TOU_PARTICIPANT_FLAT_KEYS,
  TransferOrUnloadingRequestDto,
  TransferOrUnloadingRequestFlatDto,
  touFlatToParticipants,
  touParticipantsToFlat,
} from '@ellf/common-dto';
import { FilterValue, PagedResultDto } from '@ellf/common-interfaces';
import {
  FilterCustomPermissionsEnum,
  TransferOrUnloadingViewEnum,
} from '@ellf/common-utils';
import { Update } from '@ngrx/entity';
import { map } from 'rxjs';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
// Il backend espone i soggetti coinvolti come participants[] (una riga per ruolo); il frontend lavora
// con i campi piatti (un gruppo per ruolo, come nel form). La conversione sta solo qui.
export class TransferOrUnloadingRequestApiClient extends BaseCRUDApiClient<TransferOrUnloadingRequestFlatDto> {
  baseUrl = this.config.apiEndpoint + '/transfer-or-unloading-request';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }

  private fromDto(
    dto: TransferOrUnloadingRequestDto,
  ): TransferOrUnloadingRequestFlatDto {
    const { participants, ...request } = dto;
    return { ...request, ...touParticipantsToFlat(participants) };
  }

  private fromPagedDto(
    result: PagedResultDto<TransferOrUnloadingRequestDto>,
  ): PagedResultDto<TransferOrUnloadingRequestFlatDto> {
    return { ...result, items: result.items.map((i) => this.fromDto(i)) };
  }

  private toDto(
    flat: Partial<TransferOrUnloadingRequestFlatDto>,
  ): Partial<TransferOrUnloadingRequestDto> {
    const request: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(flat)) {
      if (!TOU_PARTICIPANT_FLAT_KEYS.includes(key)) request[key] = value;
    }
    const participants = touFlatToParticipants(flat);
    return participants.length > 0 ? { ...request, participants } : request;
  }

  override getAll() {
    return this.http
      .get<TransferOrUnloadingRequestDto[]>(this.baseUrl)
      .pipe(map((items) => items.map((i) => this.fromDto(i))));
  }

  override getPaged(
    take: number,
    skip: number,
    orderBy?: { [field: string]: 'asc' | 'desc' },
    filters?: FilterValue[],
    join?: string[],
    skipFilterPermission?: FilterCustomPermissionsEnum[],
  ) {
    const mappedFilters = this.mapFilters(filters);

    return this.http
      .post<PagedResultDto<TransferOrUnloadingRequestDto>>(
        `${this.baseUrl}/paged`,
        {
          skip,
          take,
          orderBy,
          filters: mappedFilters,
          join,
          skipFilterPermission,
        },
      )
      .pipe(map((result) => this.fromPagedDto(result)));
  }

  override getById(id: string) {
    return this.http
      .get<TransferOrUnloadingRequestDto>(`${this.baseUrl}/${id}`)
      .pipe(map((dto) => this.fromDto(dto)));
  }

  override add(u: Partial<TransferOrUnloadingRequestFlatDto>) {
    return this.http
      .post<TransferOrUnloadingRequestDto>(this.baseUrl, this.toDto(u))
      .pipe(map((dto) => this.fromDto(dto)));
  }

  override update(u: Update<TransferOrUnloadingRequestFlatDto>) {
    return this.http
      .put<TransferOrUnloadingRequestDto>(
        `${this.baseUrl}/${u.id}`,
        this.toDto(u.changes),
      )
      .pipe(map((dto) => this.fromDto(dto)));
  }

  createDocument(id: string) {
    return this.http
      .post(
        `${this.baseUrl}/create-document`,
        { id: id },
        {
          responseType: 'arraybuffer',
        },
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        }),
      );
  }

  saveAndAttachDocument(id: string) {
    return this.http.post(`${this.baseUrl}/save-and-attach-document`, {
      id: id,
    });
  }

  // sendRequest(item: TransferOrUnloadingRequestDto) {
  //   return this.http.post(`${this.baseUrl}/send-request`, {
  //     item: item,
  //   });
  // }

  getPagedWithViewFlag(
    viewMode: TransferOrUnloadingViewEnum,
    take: number,
    skip: number,
    orderBy?: { [field: string]: 'asc' | 'desc' },
    filters?: FilterValue[],
    join?: string[],
  ) {
    const mappedFilters = this.mapFilters(filters);

    return this.http
      .post<PagedResultDto<TransferOrUnloadingRequestDto>>(
        `${this.baseUrl}/pagedview/${viewMode}`,
        {
          skip,
          take,
          orderBy,
          filters: mappedFilters,
          join,
        },
      )
      .pipe(map((result) => this.fromPagedDto(result)));
  }

  getRequestInPeriod(fromDate: string | undefined, toDate: string | undefined) {
    return this.http.post<RequestWidgetDto>(
      `${this.baseUrl}/get-request-in-period`,
      {
        fromDate,
        toDate,
      },
    );
  }
}
